
import { withDefaultErrorBoundary } from '@/modules/shared/hoc/withDefaultErrorBoundary';
import { AlertRemindersPageContent } from './AlertRemindersPageContent';

// Alert reminders configuration page
export const AlertRemindersPage = withDefaultErrorBoundary(AlertRemindersPageContent)
